import municipiosService from '../services/municipios.js';

export const useMunicipios = (idProvincia) => {

    const getMunicipios = (idProvincia) => municipiosService.getMunicipios(idProvincia);

    return { getMunicipios };
}